var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box"},[_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"sm":"8","order":"1"}},[_c('contact')],1),_c('b-col',{attrs:{"sm":"4","order":"2"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }